import { __decorate } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import { TierType } from '@/helpers/entities/enums/v2/TierType';
import ViewportSizeMixin from '../helpers/mixins/ViewportSizeMixin';
import UserAgentMixin from '../helpers/mixins/UserAgentMixin';
import SalesPageMixin from '../helpers/mixins/SalesPageMixin';
let FreePlans = class FreePlans extends Mixins(ViewportSizeMixin, UserAgentMixin, SalesPageMixin) {
    constructor() {
        super(...arguments);
        this.toggleProDialog = false;
    }
    get proFeatures() {
        return [
            {
                title: 'Enjoy full features on Pro Facebok Messenger Store',
                description: `Access to unlimited .csv report downloads, advance order 
                     (For QSR and Food Retail), location based pricing and customer message 
                     field on Product Page.`,
            },
            {
                title: 'Upload up to 1,000 Products',
                description: `Under Pro subscription, you can upload
                      up to 1,000 Products on your store.`,
            },
            {
                title: 'Upgrade and downgrade anytime',
                description: `Depending on your accumulated users, you can unlock and upgrade
                      your plan for free to enjoy more services and benefits from us. 
                      Plan upgrade means more VIP treatment.`,
            },
            {
                title: 'Free access on Sales Channel outside Facebook ecosystem',
                description: `Apart from Messenger Mini App, you can also sell
                      on Viber and other platforms in the future.`,
            },
            {
                title: 'Free access on available payment options for your customers',
                description: `Under Silver Plan, you can have free access to PayMaya,
                      PayMongo, Magpie, GCash and BPI subject to MID availability.`,
            },
            {
                title: 'Pro-level Technical Support',
                description: `Within 2 hours response time during weekdays via support@chatgenie.ph.`,
            },
            {
                title: 'No "Powered By Chatgenie" Branding on the Mini App',
                description: `Your customers won't see any ChatGenie branding on the Mini App`,
            },
        ];
    }
    goPro() {
        const { origin } = window.location;
        this.goToSignIn(`${origin}/login/client?plan_type=${TierType.ProStarter}`);
    }
};
FreePlans = __decorate([
    Component({
        components: {
            ProPlansDialog: () => import('./ProPlansDialog.vue'),
            AccordionPanel: () => import('./ProBenefitsAccordionPanel.vue'),
        },
    })
], FreePlans);
export default FreePlans;
